// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SearchRouteImport } from './routes/search'
import { Route as RepublishingRouteImport } from './routes/republishing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as NewsletterRouteImport } from './routes/newsletter'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DistributorsRouteImport } from './routes/distributors'
import { Route as ContactsRouteImport } from './routes/contacts'
import { Route as BrandRouteImport } from './routes/brand'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SolutionsIndexRouteImport } from './routes/solutions.index'
import { Route as ProductsIndexRouteImport } from './routes/products.index'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as ToolsStbTcoCalculatorRouteImport } from './routes/tools.stb-tco-calculator'
import { Route as SolutionsOtaUpdatesRouteImport } from './routes/solutions.ota-updates'
import { Route as SolutionsLogisticsRouteImport } from './routes/solutions.logistics'
import { Route as SolutionsIptvAppRouteImport } from './routes/solutions.iptv-app'
import { Route as SolutionsInextRemoteRouteImport } from './routes/solutions.inext-remote'
import { Route as SolutionsCustomizationRouteImport } from './routes/solutions.customization'
import { Route as SolutionsAlcatrazDmsRouteImport } from './routes/solutions.alcatraz-dms'
import { Route as ProductsInextTv6UltraRouteImport } from './routes/products.inext-tv6-ultra'
import { Route as ProductsInextTv6RouteImport } from './routes/products.inext-tv6'
import { Route as ProductsInextTv5UltraRouteImport } from './routes/products.inext-tv5-ultra'
import { Route as ProductsInextTv5RouteImport } from './routes/products.inext-tv5'
import { Route as ProductsArchiveRouteImport } from './routes/products.archive'
import { Route as GuidesSubsidizeLeaseOrSellRouteImport } from './routes/guides.subsidize-lease-or-sell'
import { Route as GuidesStbRamAndStorageRouteImport } from './routes/guides.stb-ram-and-storage'
import { Route as GuidesOwnStbVsSmartTvRouteImport } from './routes/guides.own-stb-vs-smart-tv'
import { Route as GuidesMulticastIptvVsOttRouteImport } from './routes/guides.multicast-iptv-vs-ott'
import { Route as GuidesIptvStbBuyersChecklistRouteImport } from './routes/guides.iptv-stb-buyers-checklist'
import { Route as GuidesBuildVsBuyStbRouteImport } from './routes/guides.build-vs-buy-stb'
import { Route as GuidesAospVsCertifiedAndroidTvRouteImport } from './routes/guides.aosp-vs-certified-android-tv'
import { Route as GuidesAndroidVsLinuxStbRouteImport } from './routes/guides.android-vs-linux-stb'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ProductsAccessoriesIndexRouteImport } from './routes/products.accessories.index'
import { Route as SolutionsAlcatrazDmsTrialRouteImport } from './routes/solutions.alcatraz-dms_.trial'
import { Route as SolutionsAlcatrazDmsGetStartedRouteImport } from './routes/solutions.alcatraz-dms_.get-started'
import { Route as ProductsAccessoriesIdRouteImport } from './routes/products.accessories_.$id'

const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const RepublishingRoute = RepublishingRouteImport.update({
            id: '/republishing',path: '/republishing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const NewsletterRoute = NewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DistributorsRoute = DistributorsRouteImport.update({
            id: '/distributors',path: '/distributors',getParentRoute: () => rootRouteImport
          })
const ContactsRoute = ContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => rootRouteImport
          })
const BrandRoute = BrandRouteImport.update({
            id: '/brand',path: '/brand',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SolutionsIndexRoute = SolutionsIndexRouteImport.update({
            id: '/solutions/',path: '/solutions/',getParentRoute: () => rootRouteImport
          })
const ProductsIndexRoute = ProductsIndexRouteImport.update({
            id: '/products/',path: '/products/',getParentRoute: () => rootRouteImport
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const ToolsStbTcoCalculatorRoute = ToolsStbTcoCalculatorRouteImport.update({
            id: '/tools/stb-tco-calculator',path: '/tools/stb-tco-calculator',getParentRoute: () => rootRouteImport
          })
const SolutionsOtaUpdatesRoute = SolutionsOtaUpdatesRouteImport.update({
            id: '/solutions/ota-updates',path: '/solutions/ota-updates',getParentRoute: () => rootRouteImport
          })
const SolutionsLogisticsRoute = SolutionsLogisticsRouteImport.update({
            id: '/solutions/logistics',path: '/solutions/logistics',getParentRoute: () => rootRouteImport
          })
const SolutionsIptvAppRoute = SolutionsIptvAppRouteImport.update({
            id: '/solutions/iptv-app',path: '/solutions/iptv-app',getParentRoute: () => rootRouteImport
          })
const SolutionsInextRemoteRoute = SolutionsInextRemoteRouteImport.update({
            id: '/solutions/inext-remote',path: '/solutions/inext-remote',getParentRoute: () => rootRouteImport
          })
const SolutionsCustomizationRoute = SolutionsCustomizationRouteImport.update({
            id: '/solutions/customization',path: '/solutions/customization',getParentRoute: () => rootRouteImport
          })
const SolutionsAlcatrazDmsRoute = SolutionsAlcatrazDmsRouteImport.update({
            id: '/solutions/alcatraz-dms',path: '/solutions/alcatraz-dms',getParentRoute: () => rootRouteImport
          })
const ProductsInextTv6UltraRoute = ProductsInextTv6UltraRouteImport.update({
            id: '/products/inext-tv6-ultra',path: '/products/inext-tv6-ultra',getParentRoute: () => rootRouteImport
          })
const ProductsInextTv6Route = ProductsInextTv6RouteImport.update({
            id: '/products/inext-tv6',path: '/products/inext-tv6',getParentRoute: () => rootRouteImport
          })
const ProductsInextTv5UltraRoute = ProductsInextTv5UltraRouteImport.update({
            id: '/products/inext-tv5-ultra',path: '/products/inext-tv5-ultra',getParentRoute: () => rootRouteImport
          })
const ProductsInextTv5Route = ProductsInextTv5RouteImport.update({
            id: '/products/inext-tv5',path: '/products/inext-tv5',getParentRoute: () => rootRouteImport
          })
const ProductsArchiveRoute = ProductsArchiveRouteImport.update({
            id: '/products/archive',path: '/products/archive',getParentRoute: () => rootRouteImport
          })
const GuidesSubsidizeLeaseOrSellRoute = GuidesSubsidizeLeaseOrSellRouteImport.update({
            id: '/guides/subsidize-lease-or-sell',path: '/guides/subsidize-lease-or-sell',getParentRoute: () => rootRouteImport
          })
const GuidesStbRamAndStorageRoute = GuidesStbRamAndStorageRouteImport.update({
            id: '/guides/stb-ram-and-storage',path: '/guides/stb-ram-and-storage',getParentRoute: () => rootRouteImport
          })
const GuidesOwnStbVsSmartTvRoute = GuidesOwnStbVsSmartTvRouteImport.update({
            id: '/guides/own-stb-vs-smart-tv',path: '/guides/own-stb-vs-smart-tv',getParentRoute: () => rootRouteImport
          })
const GuidesMulticastIptvVsOttRoute = GuidesMulticastIptvVsOttRouteImport.update({
            id: '/guides/multicast-iptv-vs-ott',path: '/guides/multicast-iptv-vs-ott',getParentRoute: () => rootRouteImport
          })
const GuidesIptvStbBuyersChecklistRoute = GuidesIptvStbBuyersChecklistRouteImport.update({
            id: '/guides/iptv-stb-buyers-checklist',path: '/guides/iptv-stb-buyers-checklist',getParentRoute: () => rootRouteImport
          })
const GuidesBuildVsBuyStbRoute = GuidesBuildVsBuyStbRouteImport.update({
            id: '/guides/build-vs-buy-stb',path: '/guides/build-vs-buy-stb',getParentRoute: () => rootRouteImport
          })
const GuidesAospVsCertifiedAndroidTvRoute = GuidesAospVsCertifiedAndroidTvRouteImport.update({
            id: '/guides/aosp-vs-certified-android-tv',path: '/guides/aosp-vs-certified-android-tv',getParentRoute: () => rootRouteImport
          })
const GuidesAndroidVsLinuxStbRoute = GuidesAndroidVsLinuxStbRouteImport.update({
            id: '/guides/android-vs-linux-stb',path: '/guides/android-vs-linux-stb',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ProductsAccessoriesIndexRoute = ProductsAccessoriesIndexRouteImport.update({
            id: '/products/accessories/',path: '/products/accessories/',getParentRoute: () => rootRouteImport
          })
const SolutionsAlcatrazDmsTrialRoute = SolutionsAlcatrazDmsTrialRouteImport.update({
            id: '/solutions/alcatraz-dms_/trial',path: '/solutions/alcatraz-dms/trial',getParentRoute: () => rootRouteImport
          })
const SolutionsAlcatrazDmsGetStartedRoute = SolutionsAlcatrazDmsGetStartedRouteImport.update({
            id: '/solutions/alcatraz-dms_/get-started',path: '/solutions/alcatraz-dms/get-started',getParentRoute: () => rootRouteImport
          })
const ProductsAccessoriesIdRoute = ProductsAccessoriesIdRouteImport.update({
            id: '/products/accessories_/$id',path: '/products/accessories/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BrandRoute: BrandRoute,ContactsRoute: ContactsRoute,DistributorsRoute: DistributorsRoute,FaqRoute: FaqRoute,NewsletterRoute: NewsletterRoute,PrivacyRoute: PrivacyRoute,RepublishingRoute: RepublishingRoute,SearchRoute: SearchRoute,BlogSlugRoute: BlogSlugRoute,GuidesAndroidVsLinuxStbRoute: GuidesAndroidVsLinuxStbRoute,GuidesAospVsCertifiedAndroidTvRoute: GuidesAospVsCertifiedAndroidTvRoute,GuidesBuildVsBuyStbRoute: GuidesBuildVsBuyStbRoute,GuidesIptvStbBuyersChecklistRoute: GuidesIptvStbBuyersChecklistRoute,GuidesMulticastIptvVsOttRoute: GuidesMulticastIptvVsOttRoute,GuidesOwnStbVsSmartTvRoute: GuidesOwnStbVsSmartTvRoute,GuidesStbRamAndStorageRoute: GuidesStbRamAndStorageRoute,GuidesSubsidizeLeaseOrSellRoute: GuidesSubsidizeLeaseOrSellRoute,ProductsArchiveRoute: ProductsArchiveRoute,ProductsInextTv5Route: ProductsInextTv5Route,ProductsInextTv5UltraRoute: ProductsInextTv5UltraRoute,ProductsInextTv6Route: ProductsInextTv6Route,ProductsInextTv6UltraRoute: ProductsInextTv6UltraRoute,SolutionsAlcatrazDmsRoute: SolutionsAlcatrazDmsRoute,SolutionsCustomizationRoute: SolutionsCustomizationRoute,SolutionsInextRemoteRoute: SolutionsInextRemoteRoute,SolutionsIptvAppRoute: SolutionsIptvAppRoute,SolutionsLogisticsRoute: SolutionsLogisticsRoute,SolutionsOtaUpdatesRoute: SolutionsOtaUpdatesRoute,ToolsStbTcoCalculatorRoute: ToolsStbTcoCalculatorRoute,BlogIndexRoute: BlogIndexRoute,GuidesIndexRoute: GuidesIndexRoute,ProductsIndexRoute: ProductsIndexRoute,SolutionsIndexRoute: SolutionsIndexRoute,ProductsAccessoriesIdRoute: ProductsAccessoriesIdRoute,SolutionsAlcatrazDmsGetStartedRoute: SolutionsAlcatrazDmsGetStartedRoute,SolutionsAlcatrazDmsTrialRoute: SolutionsAlcatrazDmsTrialRoute,ProductsAccessoriesIndexRoute: ProductsAccessoriesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)